import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    modalFileRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    cardContainer: {
        alignItems: "center",
        flexDirection: "row",
        overflow: "hidden",
        width: "100%",
        ...webStyle({
            transition: "all 0.2s ease"
        })
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    cardBody: {
        justifyContent: "center",
        flex: 1
    },
    cardFooter: {
        justifyContent: "center",
        alignItems: "center"
    },
    modalUploadBox: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        cursor: "pointer"
    },
    statusChipContainer: {
        justifyContent: "center",
        alignSelf: "center",
        alignItems: "center"
    },
    gridContainer: {
        flexDirection: "column",
        width: "100%"
    },
    filterSection: {
        alignItems: "flex-end",
        flexDirection: "row"
    },
    filterDropdownContainer: {
        minWidth: 200
    },
    uploadSheetInnerContent: {
        flex: 1
    },
    cardBanner: {
        position: "relative",
        aspectRatio: 4 / 5,
        height: 120,
        width: 96
    },
    bannerImage: {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0
    },
    cardTypeBadge: {
        position: "absolute",
        right: 8,
        top: 8
    },
    cardContentContainer: {
        alignItems: "center",
        flexDirection: "row",
        flex: 1
    },
    dateContainer: {
        alignItems: "center",
        flexDirection: "row"
    },
    locationContainer: {
        alignItems: "center",
        flexDirection: "row"
    },
    actionButtonsContainer: {
        alignItems: "center",
        flexDirection: "row"
    },
    photoUploadContainer: {
        alignItems: "center",
        flexDirection: "row"
    },
    modalFileRowLeft: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    uploadSheetContent: {
        alignSelf: "center",
        maxWidth: 600,
        width: "100%",
        height: 500
    },
    emptyText: {
        textAlign: "center"
    },
    modalFilesContainer: {
        flex: 1
    },
    cardTitle: {
        fontWeight: "700"
    },
    modalFilePreview: {
        height: 40,
        width: 40
    },
    searchContainer: {
        flex: 1
    },
    container: {
        width: "100%",
        flex: 1
    },
    cardWrapper: {
        width: "100%"
    }
});

export default stylesheet;
